namespace $.$$ {
	
	$mol_test_mocks.push( $ => {
		$.$mol_wait_rest = function $mol_wait_rest_mock( this: $ ) { }
		$.$mol_wait_rest_async = async function $mol_wait_rest_async_mock( this: $ ) {}
	} )

}
